import { Outlet } from 'react-router-dom';
import { useTenant, TenantProvider } from '../contexts/TenantContext';
import { DashboardDataProvider, useDashboardData } from '../contexts/DashboardDataContext';
import { OnboardingProvider } from '../contexts/OnboardingContext';
import AppLayout from '../layouts/AppLayout';
import Onboarding from './Onboarding';

// Simple loading spinner component
function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-500 text-sm">Loading...</p>
      </div>
    </div>
  );
}

// Content inside the DashboardDataProvider
function DashboardContentWithData() {
  const dashboardData = useDashboardData();

  // Show simple spinner during initial data preload
  if (!dashboardData?.isInitialLoadComplete) {
    return <LoadingSpinner />;
  }

  // Render AppLayout with nested routes via Outlet
  return (
    <OnboardingProvider>
      <AppLayout />
    </OnboardingProvider>
  );
}

function DashboardWithDataProvider() {
  const { loading, needsOnboarding } = useTenant();

  // Show spinner while tenant is loading
  if (loading) {
    return <LoadingSpinner />;
  }

  // Show onboarding if user needs to create business
  if (needsOnboarding) {
    return <Onboarding />;
  }

  // Wrap with DashboardDataProvider and show the dashboard
  return (
    <DashboardDataProvider>
      <DashboardContentWithData />
    </DashboardDataProvider>
  );
}

export default function Dashboard() {
  return (
    <TenantProvider>
      <DashboardWithDataProvider />
    </TenantProvider>
  );
}
